/* eslint-disable vue/component-name-in-template-casing */
import publicRoutes from "@/router/routes/public.js";
import authenticatedRoutes from "@/router/routes/authenticated.js";
import adminRoutes from "@/router/routes/admin.js";
import superAdminRoutes from "@/router/routes/superadmin.js";
import partnerRoutes from "@/router/routes/partner.js";
import managerRoutes from "@/router/routes/manager.js";
import invoicingAdminRoutes from "@/router/routes/invoicingadmin.js";

export default publicRoutes.concat(authenticatedRoutes, adminRoutes, superAdminRoutes, partnerRoutes, managerRoutes, invoicingAdminRoutes);
